export default "__VITE_ASSET__DTaotJKO__"